import CircularProgress from '../../../component/atoms/CircularProgress';
import Grid from '../../../component/atoms/Grid';
import { CustomCountProps } from '../../../redux/reducers/CustomCountListReducer';
import { LoadingStatus } from '../../../redux/reducers/LoadingStatusReducer';
import React, { Component } from 'react';
import CustomCount from '../../../container/molecules/CustomCountContainer';
import { GASpotEventState } from '../NegotiationCountList';

export interface CustomListHandler {
  inputValue: CustomCountProps[];
  loadingStatus: LoadingStatus;
  gaSpotEvent?: {
    [key: string]: GASpotEventState;
  };
}

type Props = CustomListHandler;
class CustomCountList extends Component<Props, any> {
  render() {
    const { inputValue, loadingStatus, gaSpotEvent } = this.props;

    return (
      <>
        <div className='headline-5 u-mb8' data-testid='title'>
          カスタムサマリ
        </div>
        <div className='uc-grid'>
          <div className='uc-grid__row' data-testid='customCountList'>
            {loadingStatus.isLoading && (
              <Grid.Col col={12} className='u-text-center u-pv16'>
                <CircularProgress isIndeterminate hasBackground={false} />
              </Grid.Col>
            )}
            {!loadingStatus.isLoading && inputValue.length === 0 && (
              <Grid.Col col={12} className='u-text-center u-pv16'>
                結果が見つかりませんでした。
              </Grid.Col>
            )}
            {!loadingStatus.isLoading &&
              inputValue.map((customCount: CustomCountProps, index: number) => (
                <CustomCount
                  key={customCount.filterKey}
                  filterKey={customCount.filterKey}
                  jobDateTime={loadingStatus.result?.jobDateTime}
                  countNum={customCount.countNum}
                  data-testid='customCount'
                  gaSpotEvent={Object.values(gaSpotEvent || {})[index]}
                />
              ))}
          </div>
        </div>
      </>
    );
  }
}

export default CustomCountList;
